import React, { Component } from 'react'

class ToDos extends Component {
  constructor(props) {
    super(props)
    this.state = { toDos: [], text: '' }
  }

  handleChange = (e) => {
    this.setState({ text: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const newItem = { id: Date.now(), item: this.state.text }
    this.setState((state) => ({
      toDos: [...state.toDos, newItem],
      text: '',
    }))
  }

  render() {
    return (
      <>
        <div>
          <h2>To Do State:</h2>
          <ul>
            {this.state.toDos.map((toDo) => (
              <li key={toDo.id}>{toDo.item}</li>
            ))}
          </ul>
        </div>
        <div className="pad-box">
          <form onSubmit={this.handleSubmit}>
            <label>What do you need to do?</label>
            <input
              type="text"
              onChange={this.handleChange}
              id="newToDo"
              value={this.state.text}
            />
            <input type="submit" defaultValue="Submit" />
          </form>
        </div>
      </>
    )
  }
}

export default ToDos
